module.exports = __webpack_public_path__ + "static/lego-a427ffcd4bb8e3f0930eb48d4661e554.png";